export const COMPANIES = 'shared/companies/page'
export const COMPANY = 'shared/companies/edit'
export const ADD_COMPANY = 'shared/companies/add'
export const UPDATE_COMPANY = 'shared/companies/update'
export const DELETE_COMPANY = 'shared/companies/delete'
